<template>

  <body>
    <IDCardASCHMA v-if="agency.id == '1539642'" />
    <IDCardFHIS v-if="agency.id == '930972'" />
    <IDCardZAMCHEMA v-else-if="agency.id != '1539642'" />
  </body>
</template>

<script>
  // import Navbar from "@/views/Navbar.vue";
  // Import component
  // import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import IDCardASCHMA from "./components/IDCardASCHMA";
  import IDCardFHIS from "./components/IDCardFHIS";
  import IDCardZAMCHEMA from "./components/IDCardZAMCHEMA";

  let agency = JSON.parse(localStorage.getItem("agency"));
  import moment from "moment";
  moment().format();

  export default {
    components: {

      IDCardASCHMA,
      IDCardFHIS,
      IDCardZAMCHEMA,
    },
    data() {
      return {
        agency: agency,
        user: null,
        trx_image: false,
        auth_user: "",
        client: "",
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        date_id_card_issued: moment().format("YYYY-MM-DD"),
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: "",
        paymentProofImage: "",
        output: "",
        singletpa: "",
        trxdocclass: "col-md-4",
        trxtableclass: "col-md-12",
        pictureShower: true,

        transaction_ref_length: 50,
      };
    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    methods: {
      async print() {
        const el = this.$refs.printNow;

        const options = {
          type: "dataURL",
        };
        this.output = await this.$html2canvas(el, options);
      },

      printMe() {
        let printContents = document.getElementById("printDiv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
      },

      fetchUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data;
            this.dependents = response.data.dependents;

            //get dependents
            this.axios
              .post(`/api/v1/auth/allDependantsUser`, {
                agency_id: agency.id,
                id_card_number: this.client.id_card_number,
                user_id: this.$route.params.id,
              })
              .then((response) => {
                console.log(response);
              })
              .catch((error) => {
                console.error(error);
              });
            //end of get dependents
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.fetchUser();
    },
  };
</script>
<style scoped>
  .spacer {
    margin-left: 1px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .spacer-image {
    margin-top: 25px;
  }

  .spacer-top-bottom {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .spacer-top {
    margin-top: 50px;
  }

  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }

  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }

  th {
    text-align: center;
  }

  td {
    width: fit-content;
    text-align: center;
  }

  .payment__proof {
    width: 20%;
  }

  .payment__proof,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block;
  }
</style>